import "materialize-css";

const MaterialTextAreaDirective = function () {
    return function (scope, element, attrs) {
        if (attrs.materialTextarea) {
            scope.$watch(attrs.materialTextarea, function (val) {
                element.trigger("autoresize");
            });
        }
    }
};

export { MaterialTextAreaDirective };